var getUserAgent = function() {
  if (window.navigator) {
    return window.navigator.userAgent || '';
  }
  return '';
};

module.exports = {
  _gecko: null,
  _trident: null,
  _webkit: null,
  _mac: null,
  userAgent: getUserAgent(),
  match: function(str) {
    return this.userAgent.indexOf(str) != -1
  },
  matchIgnoreCase: function(str) {
    return this.userAgent.toLowerCase().indexOf(str.toLowerCase()) != -1
  },
  trident: function() {
    if (this._trident === null) {
      this._trident = this.match('Trident') && this.match('MSIE');
    }
    return this._trident;
  },
  webkit: function() {
    if (this._webkit === null) {
      this._webkit = this.matchIgnoreCase('WebKit');
    }
    return this._webkit;
  },
  gecko: function() {
    if (this._gecko === null) {
      this._gecko = this.match('Gecko') && !this.trident() && !this.webkit();
    }
    return this._gecko;
  },
  mac: function() {
    if (this._mac === null) {
      this._mac = this.match('Macintosh');
    }
    return this._mac;
  },
};



//////////////////
// WEBPACK FOOTER
// ./lib/useragent.js
// module id = 19
// module chunks = 1 3